import React from 'react';
import Main from './main/Main';

const App = () => {
  return (
    <div>
      <Main />
    </div>
  );
};

export default App;
